import { render, staticRenderFns } from "./orderAdmin.vue?vue&type=template&id=203cf5f7&scoped=true&"
import script from "./orderAdmin.vue?vue&type=script&lang=js&"
export * from "./orderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./orderAdmin.vue?vue&type=style&index=0&id=203cf5f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203cf5f7",
  null
  
)

export default component.exports